const main = {
  'Config GMC': 'Google Merchant Center - การตั้งค่า Shopping Ads',
  'Config GMC Caption':
    'การเชื่อมต่อนี้จะอัปโหลดข้อมูลสินค้าผ่าน Google Content API ไปยัง Google Merchant Center ทำให้สามารถใช้ได้กับ Google Ads และบริการอื่นๆของ Google หากต้องการเชื่อมต่อกับบริการนี้ โปรดลิงก์รหัสบัญชีย่อยของ Google Merchant Center',
  'Merchant Center ID': 'Google Merchant ID',
  'Merchant has been saved successfully': 'บันทึกการตั้งค่าผู้ค้าสำเร็จแล้ว',
  'Successfully set the Region and Language for Ads Delivery':
    'ตั้งค่าภูมิภาคและภาษาสำหรับการแสดงโฆษณาสำเร็จแล้ว',
  'Please enter numbers only': 'โปรดป้อน GMC ID ที่ถูกต้อง',
  'Config region & locale': 'การตั้งค่าภูมิภาคและภาษา',
  'Config region & locale Caption':
    'หลังจากเชื่อมต่อกับ Google Merchant Center การส่งฟีดสินค้าผ่านทาง Content API สามารถจัดการได้ที่นี่และจะได้รับการอัปเดตตรงเวลา Google Merchant Center จะแสดง Shopping Ads ของคุณตามการตั้งค่าภูมิภาคและภาษา',
  Region: 'ภูมิภาคสำหรับการจัดส่ง',
  Locale: 'ภาษาสำหรับการจัดส่ง',
  'Add new languages to the list below': 'เพิ่ม',
  DATA_TABLE: {
    REGION: 'ภูมิภาค',
    LOCALE: 'ภาษา',
    ACTION: 'เปิด/ปิด',
  },
  LOCALE: {
    'zh-hant': 'ภาษาจีน - ไต้หวัน',
    'zh-tw': 'ภาษาจีน - ไต้หวัน',
    'zh-hk': 'ภาษาจีน - เขตปกครองพิเศษฮ่องกง',
    'zh-cn': 'ภาษาจีน - จีน',
    en: 'ภาษาอังกฤษ',
    ms: 'ภาษามาเลย์',
    th: 'ภาษาไทย',
    vi: 'ภาษาเวียดนาม',
    id: 'ภาษาอินโดนีเซีย',
    de: 'ภาษาเยอรมัน',
    fr: 'ภาษาฝรั่งเศส',
    ja: 'ภาษาญี่ปุ่น',
  },
  REGION: {
    TW: 'ไต้หวัน',
    CN: 'จีน',
    HK: 'ฮ่องกง',
    SG: 'สิงคโปร์',
    MY: 'มาเลเซีย',
    TH: 'ไทย',
    VN: 'เวียดนาม',
    PH: 'ฟิลิปปินส์',
    US: 'สหรัฐอเมริกา',
    AU: 'ออสเตรเลีย',
    GB: 'สหราชอาณาจักร',
  },
};

export default main;
